import { MAIN_SCOUTLYTICS_URL, isStreamCenterHost } from '../lsc/routing';

export type LegalPageSlug = 'terms' | 'privacy';

function defaultHostname(): string {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return '';
}

/** Canonical public URL for Discord Developer Portal and cross-host links. */
export function legalPageUrl(page: LegalPageSlug, hostname?: string): string {
  const host = hostname ?? defaultHostname();
  if (isStreamCenterHost(host)) {
    return `${MAIN_SCOUTLYTICS_URL}/${page}`;
  }
  return `/${page}`;
}

export function isAbsoluteLegalUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

export function isLegalPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/terms' || normalized === '/privacy';
}
